import { useState, useEffect } from 'react'
import { useTheme } from '../context/ThemeContext'
import { useLocation, useNavigate } from 'react-router-dom'

function TabNav() {
    const { theme } = useTheme()
    const location = useLocation()
    const navigate = useNavigate()
    const [showPlane, setShowPlane] = useState(false)

    const tabs = [
        { name: 'Production', path: '/dashboard' },
        { name: 'Map', path: '/map' },
        { name: 'Sales/Tank', path: '/sales' }
    ]

    const isActive = (path) => {
        if (path === '/dashboard' && (location.pathname === '/' || location.pathname === '/dashboard')) {
            return true
        }
        return location.pathname === path
    }

    const handleTabClick = (path) => {
        if (!isActive(path)) {
            setShowPlane(true)
        }
        navigate(path)
    }

    useEffect(() => {
        if (showPlane) {
            const timer = setTimeout(() => setShowPlane(false), 1800)
            return () => clearTimeout(timer)
        }
    }, [showPlane])

    return (
        <div className="relative">
            {showPlane && (
                <div
                    className="pointer-events-none fixed inset-0 overflow-hidden"
                    style={{ zIndex: 9999 }}
                >
                    <div className="airplane-fly">
                        <svg width="60" height="30" viewBox="0 0 60 30" fill="none" xmlns="http://www.w3.org/2000/svg"
                            style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}>
                            {/* Piper airplane - side profile */}
                            {/* Fuselage */}
                            <ellipse cx="28" cy="16" rx="22" ry="5" fill={theme === 'dark' ? '#e2e8f0' : '#334155'} />
                            {/* Nose cone */}
                            <path d="M50 16 L58 15.5 L50 15" fill={theme === 'dark' ? '#cbd5e1' : '#475569'} />
                            {/* Cockpit window */}
                            <path d="M38 13 Q40 10 43 12 L41 14 Z" fill="#38bdf8" opacity="0.8" />
                            {/* Wing */}
                            <path d="M22 16 L16 5 L34 5 L30 16 Z" fill={theme === 'dark' ? '#94a3b8' : '#1e293b'} />
                            {/* Tail vertical */}
                            <path d="M8 16 L4 6 L12 8 L10 16 Z" fill={theme === 'dark' ? '#94a3b8' : '#1e293b'} />
                            {/* Tail horizontal */}
                            <path d="M6 12 L2 10 L12 10 L10 12 Z" fill={theme === 'dark' ? '#94a3b8' : '#1e293b'} />
                            {/* Landing gear */}
                            <line x1="22" y1="21" x2="22" y2="26" stroke={theme === 'dark' ? '#64748b' : '#334155'} strokeWidth="1.5" />
                            <circle cx="22" cy="27" r="1.5" fill={theme === 'dark' ? '#64748b' : '#334155'} />
                            <line x1="38" y1="21" x2="38" y2="25" stroke={theme === 'dark' ? '#64748b' : '#334155'} strokeWidth="1.5" />
                            <circle cx="38" cy="26" r="1.5" fill={theme === 'dark' ? '#64748b' : '#334155'} />
                            {/* Propeller blur */}
                            <ellipse cx="56" cy="15.5" rx="1" ry="6" fill={theme === 'dark' ? '#94a3b8' : '#475569'} opacity="0.5" />
                        </svg>
                    </div>
                </div>
            )}
            <div className={`flex border-b-2 ${theme === 'dark' ? 'border-slate-800' : 'border-gray-200'} pb-0 mb-4 sm:mb-6`}>
                {tabs.map((tab) => (
                    <button
                        key={tab.path}
                        onClick={() => handleTabClick(tab.path)}
                        className={`flex-1 sm:flex-none px-3 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm font-medium rounded-t-lg transition-all ${
                            isActive(tab.path)
                                ? theme === 'dark'
                                    ? 'bg-slate-900 text-white border-b-4 border-blue-500'
                                    : 'bg-white text-gray-900 border-b-4 border-blue-600'
                                : theme === 'dark'
                                    ? 'bg-transparent text-gray-400 hover:text-gray-200'
                                    : 'bg-transparent text-gray-600 hover:text-gray-900'
                        }`}
                    >
                        {tab.name}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default TabNav
